import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import Reporttitle from '../hqProductAnalysis/Reporttitle';
import Piechart from "../hqProductAnalysis/Piechart";
import Reportdatatable from "../hqProductAnalysis/Reportdatatable";

function Productreport() {
  const [categoryChartData, setCategoryChartData] = useState([]);
  const [productCountByCategory, setProductCountByCategory] = useState([]);

  return (
    <div className="favbg">
      <div className="innerwrapper Favourites_search">
        <div className="customscroll reportcustoms">
          <Reporttitle />
          {(categoryChartData.length > 0 || productCountByCategory.length > 0) && (
            <Piechart categoryChartData={categoryChartData} productCountByCategory={productCountByCategory}/>
          )}
          <Reportdatatable setCategoryChartData={setCategoryChartData} setProductCountByCategory={setProductCountByCategory}/>
        </div>
      </div>
    </div>
  );
}

export default Productreport;
